import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getVacantList = async () => {
  const response = await axios.get(`${base_url}vacantpostion`, config);

  return response.data;
};
const vacantService = {
  getVacantList,
};

export default vacantService;
